import { api } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { ContractCreationType } from './contract-creation-type.interface';

export default {
   async get() {
      return await api.get<ApiResource<Array<ContractCreationType>>>('/contract-creation-type').then((response) => {
         return response.data;
      });
   },
};
